import AppInfoContext from "src/provider/state-manager/appInfoProvider";
import { useContext } from "react";

function SvgComponent(props: any) {
  const {
    info: { theme },
  } = useContext(AppInfoContext);

  return (
    <svg
      width="106"
      height="106"
      viewBox="0 0 106 106"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.2379 18.2393L87.7595 87.761M87.7592 18.2393L18.2375 87.761M102.165 53.0002C102.165 80.1542 80.1527 102.167 52.9987 102.167C25.8447 102.167 3.83203 80.1542 3.83203 53.0002C3.83203 25.8462 25.8447 3.8335 52.9987 3.8335C80.1527 3.8335 102.165 25.8462 102.165 53.0002Z"
        stroke="#D92D20"
        stroke-width="5.88"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export default SvgComponent;
